export default __webpack_public_path__ + "static/media/ic_user_active_TP.f37cbafe.svg";